import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


export function fvScrollAnimation() {

	if (window.matchMedia('(max-width: 767px)').matches) {
    return;
	}

  const fv = document.querySelector('.p-fv');
  const typoPin = document.querySelector('.p-fv_typo_pin');
  const typo = document.querySelector('.p-fv_typo');
  const typoCont = document.querySelector('.p-fv_typo_cont');

  const tyochin = document.querySelector('.p-fv_tyochin');
  const tyochinItems = gsap.utils.toArray('.p-fv_tyochin_cmn');

  const bg = document.querySelector('.p-fv_bg');


  if (
    !fv ||
    !typoPin ||
    !typo ||
    !typoCont ||
    !tyochin ||
    !tyochinItems.length ||
    !bg
  ) {
    return;
  }


  const init = () => {

    /**
     * ========================================
     * TYPOの最終的な高さを取得
     * ========================================
     *
     * Pin開始前に一度だけ数値として取得します。
     *
     * スクロール中に毎回getBoundingClientRect()
     * しないこともガタつき防止になります。
     */
    const typoStyle = getComputedStyle(typo);

    const paddingTop =
      parseFloat(typoStyle.paddingTop) || 0;

    const paddingBottom =
      parseFloat(typoStyle.paddingBottom) || 0;


    const typoNaturalHeight =
      typoCont.offsetHeight +
      paddingTop +
      paddingBottom;


    /**
     * 初期値を明示
     */
    gsap.set(typo, {
      height: window.innerHeight * 0.9,
    });


    /**
     * ========================================
     * 01. TYPO HEIGHT
     * ========================================
     *
     * 90vh
     * ↓
     * コンテンツ本来の高さ
     */
    gsap.to(typo, {

      height: typoNaturalHeight,

      ease: 'none',

      scrollTrigger: {

        trigger: fv,

        start: 'top top',

        endTrigger: bg,
        end: 'top top',

        scrub: true,

        // markers: {
        //   startColor: 'blue',
        //   endColor: 'blue',
        // },

      },

    });


    /**
     * ========================================
     * 02. TYPO PIN
     * ========================================
     *
     * ★ .p-fv_typo はPinしない
     *
     * 高さが一切変化しない
     * .p-fv_typo_pin をPinします。
     */
    ScrollTrigger.create({

      trigger: fv,

      start: 'top top',

      endTrigger: bg,
      end: 'top top',

      pin: typoPin,

      pinSpacing: false,

      anticipatePin: 1,

      // markers: true,

    });


    /**
     * ========================================
     * 提灯画像高さ
     * ========================================
     */
    const getTyochinHeight = () => {

      return Math.max(
        ...tyochinItems.map((item) => {

          const img = item.querySelector('img');

          if (!img) {
            return item.offsetHeight;
          }

          return img.getBoundingClientRect().height;

        })
      );

    };


    /**
     * ========================================
     * 提灯移動量
     * ========================================
     *
     * ここが今回の重要ポイント。
     *
     * 画像が100vhより高い場合
     *   → 下端が画面下端まで来る位置
     *
     * 画像が100vhより低い場合
     *   → 画像自体の高さ分だけ上へ送る
     *
     * 今回：
     *
     * 365px → -365px
     *
     * になるため必ずスクロールします。
     */
    const getTyochinMoveY = () => {

      const contentHeight =
        getTyochinHeight();

      const viewportHeight =
        window.innerHeight;


      if (contentHeight > viewportHeight) {

        return -(
          contentHeight -
          viewportHeight
        );

      }


      return -contentHeight;

    };


    /**
     * 初期位置
     */
    gsap.set(tyochinItems, {
      y: 0,
    });


    /**
     * ========================================
     * 03. 提灯 Pin + Scroll
     * ========================================
     */
    gsap.to(tyochinItems, {

      y: () => getTyochinMoveY(),

      ease: 'none',

      scrollTrigger: {

        trigger: fv,

        start: 'top top',

        endTrigger: bg,
        end: 'bottom center',

        scrub: true,

        pin: tyochin,

        pinSpacing: false,

        anticipatePin: 1,

        invalidateOnRefresh: true,

        // markers: {
        //   startColor: 'red',
        //   endColor: 'red',
        // },

      },

    });


    ScrollTrigger.refresh();

  };


  if (document.readyState === 'complete') {

    init();

  } else {

    window.addEventListener(
      'load',
      init,
      {
        once: true,
      }
    );

  }

}